// extracted by mini-css-extract-plugin
export var advantage = "index-module--advantage--YF+Fe";
export var image = "index-module--image--7jgRk";
export var mediaStyle = "index-module--mediaStyle--kzAFw";
export var node = "index-module--node--UUTbR";
export var title = "index-module--title--kMqlc";